import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { Divider as AntDivider } from "antd";

const RootContainer = styled.div`
	padding: 12px 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Title = styled.div`
	text-align: center;
	color: #f9f9f9;
	font-size: 14px;
	font-style: normal;
	font-weight: 100;
	line-height: 24px;
	width: fit-content;
`;

const RulesContainer = styled.div`
	color: #cfcfd1 !important;
	font-size: 14px;
	font-style: normal;
	font-weight: 300;
	line-height: 28px;
	/* span{
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 28px;
  } */
`;
export const DividerWrapper = styled.div`
	width: 100px;
	margin: 0 auto;
`;

export const Divider = styled(AntDivider)`
	margin: 16px 0 24px;
	border-color: #d28a28;
`;

const Rules = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state } = useLocation();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
	};

	if (!state) {
		return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
	}

	const ruleText =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? state.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
			? state.text_mm
			: state.text_ch;
	return (
		<>
			<Topbar title={t("spin.rule")} goBack={goBack} shadow={false} />
			<RootContainer>
				{/* localization needed */}
				<Title> {t("spin.ruleTitle")} </Title>
				<DividerWrapper>
					<Divider style={{ borderColor: "#D28A28" }} />
				</DividerWrapper>
				<RulesContainer dangerouslySetInnerHTML={{ __html: ruleText }} />
			</RootContainer>
		</>
	);
};

export default Rules;
